'use strict';

(function () {
      document.addEventListener("DOMContentLoaded", function () {
            const offset = 0;

            // URLのハッシュ値を取得
            const urlhash = location.hash;

            // ハッシュ値があればページ内スクロール
            if (urlhash) {
                  window.scrollTo(0, 0); // スクロール位置をトップにリセット
                  setTimeout(function () {
                        scrollToAnker(urlhash, offset);
                  }, 1000);
            }

            // ハッシュリンククリック時の動作
            document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
                  anchor.addEventListener("click", function (event) {
                        event.preventDefault(); // デフォルトのリンク動作を無効化
                        const href = this.getAttribute("href");
                        const target = href === "#" || href === "" ? document.documentElement : document.querySelector(href);
                        scrollToAnker(target, offset);
                  });
            });
      });

      function scrollToAnker(hash, offset) {
            const target = typeof hash === "string" ? document.querySelector(hash) : hash;
            let targetHight = 0;
            targetHight = $('.sale-shop-sort').outerHeight(true) ;

            if (target) {
                  const position = target.getBoundingClientRect().top + window.pageYOffset - targetHight - offset;
                  const positionCeil = Math.ceil(position);

                  // スムーズスクロールを実行
                  window.scrollTo({
                        top: positionCeil,
                        behavior: "smooth"
                  });
            }
      }
})();